import { useSyncExternalStore } from 'react';
let now = Date.now(), timer = null;
const listeners = new Set();
function publish() { now = Date.now(); listeners.forEach(listener => listener()); }
function schedule() {
  clearTimeout(timer); timer = null;
  if (!document.hidden && listeners.size) timer = setTimeout(() => { publish(); schedule(); }, 60000);
}
function onVisibility() { if (!document.hidden) publish(); schedule(); }
const subscribe = listener => {
  if (!listeners.size) { now = Date.now(); document.addEventListener('visibilitychange', onVisibility); }
  listeners.add(listener); if (timer === null) schedule();
  return () => { listeners.delete(listener); if (!listeners.size) { clearTimeout(timer); timer = null; document.removeEventListener('visibilitychange', onVisibility); } };
};
export const useMinuteClock = () => useSyncExternalStore(subscribe, () => now, () => now);
